const baseUrl = process.env.REACT_APP_NOTIFIER_URI;
const applicationId = process.env.REACT_APP_APPLICATION_ID;

const notificationsService = {
    async getUnreadCount(clientId) {
        const params = new URLSearchParams({ clientId, applicationId });
        const response = await fetch(`${baseUrl}/Notifications/v1/GetUnreadCount?${params}`);
        if (!response.ok) throw new Error('Ошибка получения счётчика уведомлений');
        return await response.json();
    },

    async getNotifications(clientId, pageNumber = 1, pageSize = 20) {
        const params = new URLSearchParams({ clientId, applicationId, pageNumber, pageSize });
        const response = await fetch(`${baseUrl}/Notifications/v1/GetNotifications?${params}`);
        if (!response.ok) throw new Error('Ошибка получения уведомлений');
        return await response.json();
    },

    async markAsRead(notificationId) {
        const params = new URLSearchParams({ notificationId });
        const response = await fetch(`${baseUrl}/Notifications/v1/MarkAsRead?${params}`, { method: 'POST' });
        if (!response.ok) throw new Error('Ошибка отметки уведомления');
    },
};

export default notificationsService;
